import { makeStyles, Paper } from '@material-ui/core';
import React from 'react';
const useStyles = makeStyles((theme) => ({
    showMoreResults: {
        borderBottomColor: theme.palette.divider,
        borderBottomStyle: 'solid',
        borderBottomWidth: '1px',
        color: theme.palette.grey.A400,
        fontStyle: 'italic',
        padding: theme.spacing(1),
        textAlign: 'center'
    }
}));
export const PaperComponent = ({ moreResults, moreResultsText }) => {
    const classes = useStyles();
    return ({ children }) => (React.createElement(Paper, null,
        moreResults
            ? (React.createElement("div", { className: classes.showMoreResults }, moreResultsText))
            : null,
        children));
};
//# sourceMappingURL=PaperComponent.js.map